<template>
  <div
    class="wrap"
    :style="{ width: '1060px', margin: '0 auto' }"
  >
    <div style="display: flex">
      <div
        :ref="(el) => (nav = (el as HTMLAnchorElement))"
        style="
          flex: 1;
          margin-right: 32px;
          box-sizing: border-box;
          overflow-y: scroll;
          height: 100vh;
        "
      >
        <ul
          style="margin: 0; padding: 0; list-style-type: none"
          v-for="(items, key) in categories"
        >
          <li
            class="li"
            :key="key"
          >
            {{ key }}
          </li>
          <a
            v-for="(item, itemname) in items"
            :key="itemname"
            :href="`#${base}${itemname}`"
            class="link"
            :ref="(el) => (links.push(el as HTMLAnchorElement))"
            :style="{
              position: 'relative',
              display: 'block',
              color: '#666666'
            }"
          >
            {{ itemname }}
          </a>
        </ul>
      </div>
      <div style="flex: 0 0 820px; padding-top: 10px"><Sandbox></Sandbox></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { take, tap } from "rxjs/operators";
import { getElementPositionInPage } from "@zyzgroup/core-web";
import Sandbox from "../components/rxmarbles/Sandbox.vue";
import { categories } from "../components/rxmarbles/data";
import { store$ } from "../components/rxmarbles/rxMarble";

const base = "/rx/";

const nav = ref<HTMLElement>();
const links = ref<HTMLAnchorElement[]>([]);

onMounted(() => {
  store$
    .pipe(
      take(1),
      tap((route) => {
        const link = links.value.find(
          (link) => link.href.indexOf(`#${base}${route}`) >= 0
        );
        if (link && nav.value) {
          (nav.value as HTMLElement).scrollTo({
            top: getElementPositionInPage(link as HTMLElement).y
          });
        }
      })
    )
    .subscribe();
});
</script>

<style scoped>
.wrap {
  position: relative;
  background: #ececec;
  font-family: "Source Sans Pro", sans-serif;
  color: #323232;
  margin: 0;
  padding-left: 0.4em;
}

a {
  color: #3ea1cb;
  text-decoration: underline;
  font-size: 1em;
  padding-left: 0.4em;
}

a.link:hover {
  color: #000000 !important;
}

a.link:hover::after {
  display: inline-block;
  position: absolute;
  right: 10px;
  content: "❯";
}

.li {
  text-transform: uppercase;
  font-size: 0.8em;
  color: #000000;
  font-weight: bold;
  margin-top: 20px;
}
</style>
